var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Send",
    clipPath: "url(#clip0_8887_2554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 15L20 4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0001 4L13.5001 22C13.4562 22.0957 13.3858 22.1769 13.2971 22.2338C13.2085 22.2906 13.1054 22.3209 13.0001 22.3209C12.8948 22.3209 12.7917 22.2906 12.703 22.2338C12.6144 22.1769 12.5439 22.0957 12.5001 22L9.00007 15L2.00007 11.5C1.90433 11.4561 1.8232 11.3857 1.76632 11.2971C1.70944 11.2084 1.6792 11.1053 1.6792 11C1.6792 10.8947 1.70944 10.7916 1.76632 10.7029C1.8232 10.6143 1.90433 10.5439 2.00007 10.5L20.0001 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8887_2554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.89aaf7769ee3f447fadc17928270aab8.svg";
export { ForwardRef as ReactComponent };